import {FETCH_MAP_CITIES_REQUEST, FETCH_MAP_CITIES_SUCCES, FETCH_MAP_CITIES_ERROR} from '../constants/Map'

const initialState = {
  list: [],
  hasErrored: false,
  isLoading: false
}

export default function map(state = initialState, action) {
  switch (action.type) {
      case FETCH_MAP_CITIES_REQUEST:
        return {...state, isLoading: true};
      case FETCH_MAP_CITIES_SUCCES:
        return {...state, list: action.payload.results, isLoading: false};
      case FETCH_MAP_CITIES_ERROR:
        return {...state, hasErrored: true, isLoading: false};
      default:
        return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/map.js